import axios from '@axios'
import axiosExt from 'axios'
import { saveAs } from 'file-saver'
import JSZip from 'jszip'
import moment from 'moment'

export default {
    namespaced: true,
    state: {
        comprobantes: [],
        progress: {
            max: null,
            value: 0,
        },
        firmas: [],
    },
    getters: {
        getComprobantes: state => state.comprobantes.data,
        getProgress: state => state.progress,
        getFirmas: state => state.firmas,
    },
    mutations: {
        SET_COMPROBANTES(state, comprobantes) {
            state.comprobantes = comprobantes
        },
        SET_PROGRESS(state, progress) {
            state.progress = progress
        },
        SET_FIRMAS(state, firmas) {
            state.firmas = firmas
        },
    },
    actions: {
        fetchComprobantes({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/evoucher/transacciones/comprobante', { params })
                    .then(async response => {
                        if (params.formato && params.formato === 'zip') {
                            let zip = new JSZip()
                            let comprobantes = response.data.map(comprobante => {
                                return {
                                    xml: `${import.meta.env.VITE_SP_SRI_DOWMLOADER}${comprobante.ruta_documento.ruta}`,
                                    pdf: `${
                                        import.meta.env.VITE_SP_SRI_DOWMLOADER
                                    }${comprobante.ruta_documento.ruta.replace('.xml', '.pdf')}`,
                                    filename: comprobante.claveAcceso,
                                    fechaEmision: comprobante.fechaEmision,
                                    razonSocial: comprobante.razonSocial,
                                }
                            })
                            commit('SET_PROGRESS', { max: comprobantes.length, value: 0 })
                            for (let index = 0; index < comprobantes.length; index++) {
                                let comprobante = comprobantes[index]
                                let xml = await axiosExt.get(comprobante.xml, { responseType: 'blob' })
                                // Blob to XML Text
                                let blob = new Blob([xml.data], {
                                    type: 'application/xml',
                                })
                                let reader = new FileReader()
                                reader.onload = function () {
                                    let xml_string = `<autorizacion><estado>AUTORIZADO</estado><numeroAutorizacion>${comprobante.filename}</numeroAutorizacion><fechaAutorizacion>${comprobante.fechaEmision} 00:00:00</fechaAutorizacion><ambiente>PRODUCCION</ambiente><comprobante><![CDATA[`
                                    xml_string += reader.result
                                    xml_string += ']]></comprobante><mensajes/></autorizacion>'
                                    let xml_file = new Blob([xml_string], { type: blob.type })
                                    zip.file(`${comprobante.razonSocial} - ${comprobante.filename}.xml`, xml_file)
                                }
                                reader.readAsText(blob)
                                // Blob to XML Text
                                let pdf = await axiosExt.get(comprobante.pdf, { responseType: 'blob' })
                                zip.file(`${comprobante.razonSocial} - ${comprobante.filename}.pdf`, pdf.data)
                                commit('SET_PROGRESS', { max: comprobantes.length, value: index + 1 })
                            }
                            let contenido = await zip.generateAsync({ type: 'blob' })
                            let filename =
                                params.rango[0] == params.rango[1]
                                    ? moment(params.rango[0]).format('DDMMMYY')
                                    : `${moment(params.rango[0]).format('DDMMMYY')} - ${moment(params.rango[1]).format(
                                          'DDMMMYY'
                                      )}`
                            saveAs(contenido, `${filename}.zip`)
                            commit('SET_PROGRESS', { max: null, value: 0 })
                            resolve([])
                        } else if (params.formato && params.formato === 'xlsx') {
                            resolve(response.data)
                        } else {
                            commit('SET_COMPROBANTES', response.data)
                            resolve(response)
                        }
                    })
                    .catch(error => reject(error))
            })
        },
        descargarComprobante({ commit }, data) {
            return new Promise((resolve, reject) => {
                axiosExt({
                    url: `${import.meta.env.VITE_SP_SRI_DOWMLOADER}${
                        data.pdf ? data.ruta.replace('.xml', '.pdf') : data.ruta
                    }`,
                    method: 'GET',
                    responseType: 'blob',
                })
                    .then(response => {
                        let blob = new Blob([response.data], {
                            type: data.pdf ? 'application/pdf' : 'application/xml',
                        })
                        if (data.xml) {
                            let reader = new FileReader()
                            reader.onload = function () {
                                let xml_string = `<autorizacion><estado>AUTORIZADO</estado><numeroAutorizacion>${data.filename}</numeroAutorizacion><fechaAutorizacion>${data.fechaEmision} 00:00:00</fechaAutorizacion><ambiente>PRODUCCION</ambiente><comprobante><![CDATA[`
                                xml_string += reader.result
                                xml_string += ']]></comprobante><mensajes/></autorizacion>'
                                let xml_file = new Blob([xml_string], { type: blob.type })
                                saveAs(xml_file, `${data.razonSocial} - ${data.filename}.xml`)
                            }
                            reader.readAsText(blob)
                        } else {
                            saveAs(blob, `${data.razonSocial} - ${data.filename}.pdf`)
                        }
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        contarComprobantes({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/evoucher/dashboard/vouchers', { params })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        calendarioComprobantes({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/evoucher/dashboard/time-series', { params })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        subirComprobantes({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/evoucher/mantenimiento/cargar', data, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        deleteComprobante({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .delete('/api/auth/evoucher/transacciones/comprobante', { params })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        migrarDatosIpsp({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/evoucher/transacciones/comprobante/migrarComprobantesVoucherIpsp', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        signFile({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/evoucher/transacciones/sign', data, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchFirmas({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/evoucher/mantenimiento/firma', { params })
                    .then(response => {
                        commit('SET_FIRMAS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        createFirma({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/evoucher/mantenimiento/firma', data, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        updateFirma({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/evoucher/mantenimiento/firma/update', data, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchPermisosFirma({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/evoucher/mantenimiento/firma/permisos', { params })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        createPermisosFirma({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/evoucher/mantenimiento/firma/permisos', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        deletePermisosFirma({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .delete('/api/auth/evoucher/mantenimiento/firma/permisos', { params })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchDocumentos({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/evoucher/transacciones/sign/documentos', { params })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
    },
}
